export enum AttendButtonState {
    Attending = 'attending',
    NotAttending = 'not-attending',
    OnWaitingList = 'on-waiting-list',
    NotOnWaitingList = 'not-on-waiting-list',
}
